import { CaretLeft, CaretRight } from '@phosphor-icons/react';

export const authHeaders = () => {
  const token = localStorage.getItem('access_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const STATUS_STYLES = {
  overdue:   { bg: '#FBE7E7', fg: '#B91C1C', label: 'Overdue' },
  due_soon:  { bg: '#FEF3C7', fg: '#A16207', label: 'Due soon' },
  ok:        { bg: '#E7F5EC', fg: '#047857', label: 'OK' },
  no_record: { bg: '#F5F5F4', fg: '#57534E', label: 'No record' },
  na:        { bg: '#FAFAF9', fg: '#A8A29E', label: 'N/A' },
  out:       { bg: '#FBE7E7', fg: '#B91C1C', label: 'Out of stock' },
  low:       { bg: '#FEF3C7', fg: '#A16207', label: 'Low' },
  pass:      { bg: '#E7F5EC', fg: '#047857', label: 'PASS' },
  fail:      { bg: '#FBE7E7', fg: '#B91C1C', label: 'FAIL' },
};

export function StatusChip({ status, label, size }) {
  const s = STATUS_STYLES[status] || STATUS_STYLES.na;
  const cls = size === 'md'
    ? 'text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap'
    : 'text-[10px] font-semibold px-2 py-0.5 rounded-full whitespace-nowrap';
  return (
    <span className={cls} style={{ backgroundColor: s.bg, color: s.fg }}>
      {label || s.label}
    </span>
  );
}

export const fmtDate = (s) => {
  if (!s) return '—';
  const d = new Date(String(s).slice(0, 10));
  if (isNaN(d.getTime())) return String(s).slice(0, 10);
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: '2-digit' });
};

export const todayISO = () => new Date().toISOString().slice(0, 10);

export function Pager({ page, totalPages, count, label, onPage, testid, pageSize = 8 }) {
  if (totalPages <= 1) return null;
  return (
    <div className="flex items-center justify-between gap-3 px-4 py-2.5 border-t border-[#EDE6D8] bg-[#FCFAF6]/60" data-testid={testid}>
      <span className="text-xs text-[#78716C]">
        Showing <span className="font-semibold text-[#1C1917]">{(page - 1) * pageSize + 1}–{Math.min(page * pageSize, count)}</span> of{' '}
        <span className="font-semibold text-[#1C1917]">{count}</span> {label}
      </span>
      <div className="flex items-center gap-1.5">
        <button
          type="button"
          onClick={() => onPage(Math.max(1, page - 1))}
          disabled={page <= 1}
          data-testid={`${testid}-prev`}
          className="inline-flex items-center gap-1 h-7 px-2 rounded-lg border border-[#EDE6D8] bg-white text-xs font-semibold text-[#0A2540] hover:bg-[#FCFAF6] transition disabled:opacity-40 disabled:cursor-not-allowed"
        >
          <CaretLeft size={11} weight="bold" /> Prev
        </button>
        <span className="text-xs font-mono text-[#0A2540] px-1">{page}/{totalPages}</span>
        <button
          type="button"
          onClick={() => onPage(Math.min(totalPages, page + 1))}
          disabled={page >= totalPages}
          data-testid={`${testid}-next`}
          className="inline-flex items-center gap-1 h-7 px-2 rounded-lg border border-[#EDE6D8] bg-white text-xs font-semibold text-[#0A2540] hover:bg-[#FCFAF6] transition disabled:opacity-40 disabled:cursor-not-allowed"
        >
          Next <CaretRight size={11} weight="bold" />
        </button>
      </div>
    </div>
  );
}

export const escHtml = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

export function openPrintWindow(title, bodyHtml) {
  const w = window.open('', '_blank', 'width=860,height=920');
  if (!w) return;
  w.document.write(`<!doctype html><html><head><meta charset="utf-8"/><title>${escHtml(title)}</title>
  <style>
    * { box-sizing: border-box; }
    body { font-family: 'Segoe UI', Arial, sans-serif; color: #1C1917; margin: 32px; }
    h1 { font-size: 20px; margin: 0 0 2px; color: #0A2540; }
    .sub { font-size: 12px; color: #78716C; margin-bottom: 20px; }
    .meta { display: grid; grid-template-columns: repeat(2, 1fr); gap: 6px 24px; margin-bottom: 20px; font-size: 13px; }
    .meta b { color: #0A2540; }
    table { width: 100%; border-collapse: collapse; font-size: 13px; }
    th { text-align: left; background: #FCFAF6; color: #57534E; text-transform: uppercase; font-size: 10px; letter-spacing: 0.08em; padding: 8px; border-bottom: 2px solid #0A2540; }
    td { padding: 8px; border-bottom: 1px solid #EDE6D8; }
    .pass { color: #047857; font-weight: 700; }
    .fail { color: #B91C1C; font-weight: 700; }
    .footer { margin-top: 28px; font-size: 11px; color: #A8A29E; }
    @media print { body { margin: 10mm; } }
  </style></head><body>${bodyHtml}</body></html>`);
  w.document.close();
  w.focus();
  setTimeout(() => { w.print(); }, 350);
}
